<template>
    <div class="background-item" @click="$emit('click')">
        <div :style="innerStyle">
            <isc-image class="background-item__image" :src="background" fit="cover" />
        </div>

        <div
            v-if="removable"
            title="移除该图片"
            class="background-item__removable d-inline-flex align-center justify-center"
            @click.stop="$emit('remove')"
        >
            <isc-svg-icon size="20px" name="iscon-bold-close" />
        </div>

        <div v-if="selected" class="background-item__selected d-inline-flex align-center justify-center">
            <isc-svg-icon size="40px" name="iscon-success" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'TheBackgroundItem',

    props: {
        ratio: {
            type: Number,
            default: 120 / 75
        },

        background: {
            type: String,
            default: ''
        },

        removable: {
            type: Boolean,
            default: false
        },

        selected: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        innerStyle() {
            return {
                paddingBottom: 100 / this.ratio + '%'
            };
        }
    }
};
</script>

<style lang="scss" scoped>
.background-item {
    position: relative;

    &__image {
        position: absolute;
        width: 100%;
        height: 100%;
    }

    &__removable {
        position: absolute;
        right: 0;
        top: 0;
        background: #ffffff;
        color: #999999;
        cursor: pointer;
        padding: 4px;

        &:hover {
            color: #666666;
        }
    }

    &__selected {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: $app-success-color;
    }
}
</style>
